// Convert data to CSV format
export const convertToCSV = (data: any[], headers: string[]) => {
  const csvRows = [];
  
  // Add headers
  csvRows.push(headers.join(','));
  
  // Add data rows
  data.forEach((row) => {
    const values = headers.map((header) => {
      // Map header to data key
      const key = getKeyFromHeader(header);
      const value = row[key];
      // Escape commas and quotes in values
      const escaped = String(value).replace(/"/g, '""');
      return `"${escaped}"`;
    });
    csvRows.push(values.join(','));
  });
  
  return csvRows.join('\n');
};

// Map column headers to data keys
export const getKeyFromHeader = (header: string) => {
  const headerMap: Record<string, string> = {
    // Projects
    'Project Name': 'name',
    'Total Client Views': 'totalViews',
    'Unique Client Views': 'uniqueViews',
    'Active Agents': 'activeAgents',
    '2D Tours Completed': 'tours2D',
    'VR Tours Completed': 'toursVR',
    // Agents
    'Agent ID': 'id',
    'Last Active': 'lastActive',
    'Total Clients': 'totalClients',
    'Newly Onboarded Clients': 'newlyOnboarded',
  };
  return headerMap[header] || header;
};

// Download CSV file
export const downloadCSV = (csvContent: string, filename: string) => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

// Handle Projects download - now accepts data and columns as parameters
export const handleDownloadProjects = (sortedProjects: any[], projectColumns: string[]) => {
  const csv = convertToCSV(sortedProjects, projectColumns);
  const timestamp = new Date().toISOString().split('T')[0];
  downloadCSV(csv, `projects-analytics-${timestamp}.csv`);
};

// Handle Agents download - now accepts data and columns as parameters
export const handleDownloadAgents = (sortedAgents: any[], agentColumns: string[]) => {
  const csv = convertToCSV(sortedAgents, agentColumns);
  const timestamp = new Date().toISOString().split('T')[0];
  downloadCSV(csv, `agents-analytics-${timestamp}.csv`);
};
